import * as React from "react";
import { styled } from "@mui/system";
import MUITabs from "@mui/material/Tabs";
import { TabsProps as TabsPropsMUI } from "@mui/material/Tabs";
export interface TabsProps extends TabsPropsMUI {
  sticky?: boolean;
  open?: boolean;
}

export const Tabs = styled(
  (props: TabsProps) => {
    return <MUITabs {...props} />;
  },
  {
    name: "Tabs",
    slot: "Root",
    shouldForwardProp: (prop) => prop !== "sticky" && prop !== "myProp",
    overridesResolver: (props, styles) => [styles.root]
  }
)(({ theme, orientation, sticky, open }) => ({
  "&.MuiTabs-root.MuiTabs-vertical": {
    borderBottom: 0,
    position: "fixed",
    boxShadow: "5px -5px 5px -3px rgba(0,0,0,0.2)"
  },
  "&.MuiTabs-root.MuiTabs-vertical .MuiTabs-fixed .MuiTabs-indicator": {
    display: "none"
  },
  "&.MuiTabs-root .MuiTabs-fixed .MuiTabs-flexContainerVertical": {
    background: theme.palette.primary.surfaceDefault,
    height: "100%",
    maxWidth: 48,
    width: 48,
    alignItems: "center",
    "& .MuiTab-root": {
      borderBottom: "none !important",
      width: 40,
      minWidth: 40,
      minHeight: 40,
      padding: 0,
      margin: "4px 0",
      "& svg": {
        fontSize: 14,
        color: theme.palette.primary.borderActive,
        marginBottom: 0
      },
      "& .MuiStack-root": {
        display: "none"
      }
    }
  },
  "&.MuiTabs-root .MuiTabs-fixed .MuiTabs-flexContainerVertical .MuiButtonBase-root.Mui-disabled.MuiTab-root":
    {
      "& svg": {
        color: theme.palette.primary.borderDisabled
      },
      "&:hover": {
        background: "transparent"
      }
    },
  "&.MuiTabs-root .MuiTabs-fixed .MuiTabs-flexContainerVertical .MuiButtonBase-root.MuiTab-root.Mui-selected":
    {
      background: theme.palette.primary.background + " !important",
      borderRadius: 2,
      borderBottom: "none !important",
      "& svg": {
        color: theme.palette.primary.textTitleColor + " !important"
      }
    },
  ...(orientation === "vertical" && {
    "&.MuiTabs-root.MuiTabs-vertical": {
      borderBottom: "none",
      "& .MuiTab-root:hover": {
        background: theme.palette.primary.interactiveSelectedColor
      }
    }
  }),

  ...(sticky &&
    orientation === "vertical" && {
      "&.MuiTabs-root.MuiTabs-vertical": {
        position: "absolute",
        background: theme.palette.primary.background,
        zIndex: 2001,
        boxShadow:
          "-5px 0px 5px -3px rgba(0, 0, 0, 0.2), 0px -5px 5px -5px rgba(0, 0, 0, 0.2), 0px 5px 5px -5px rgba(0, 0, 0, 0.2)",
        "& .MuiTab-root:hover": {
          background: theme.palette.primary.interactiveSelectedColor
        }
      }
    })
}));
